<template>
  <div v-if="! isRated && ! submitting">
    <div class="conversation__message-input-panel">
      <div class="conversation__message-input-label-field">{{ $t('conversation.survey.post.body')}}</div>
      <div style="position: relative; text-align:center">
        <button class="--icon"><ThumbsUp @click="thumbsUp" size="30"></ThumbsUp></button>
        <button class="--icon"><ThumbsDown @click="thumbsDown" size="30"></ThumbsDown></button>
      </div>
    </div>
  </div>
  <div v-else-if="! isRated && submitting">
<!--    <div class="conversation__message-input-panel">-->
    <div class="conversation__message-input-panel">
      <BaseSpinner size="is-medium" delay="0" :loading="submitting"/>
    </div>
  </div>
  <div v-else>
    <div class="conversation__message-input-panel">
      <div class="conversation__message-input-label-field">{{ $t('conversation.survey.post.thank_you_msg') }}</div>
    </div>
  </div>
</template>

<script>
import ConversationService from "@/services/conversation.service";
import { ThumbsUp, ThumbsDown } from 'lucide-vue-next';

export default {
  name: 'ConversationSurvey',
  props: [
      'id'
  ],
  data() {
    return {
      input: '',
      isRated: false,
      submitting: false
    }
  },
  computed: {
  },
  methods: {
    thumbsUp() {
      this.rateConversation(10)
    },
    thumbsDown() {
      this.rateConversation(1)
    },
    rateConversation(score) {
      this.submitting = true
      ConversationService.rateConversation(this.id, score).then(() => {
        this.$emit('rated',score)
        setTimeout(() => {
          this.submitting = false
          this.isRated = true
        }, 3000)
      }).catch(() => {
        this.$toast.show(this.$t('common.toast.generic_error'));
        this.submitting = false
        this.isRated = false
      })
    }
  },
  components: {
    ThumbsUp, ThumbsDown
  }
}
</script>

<style lang="scss" scoped>
  //
  // input message
  //

  .conversation__message-input-panel {
    position: relative;
    padding: 26px 24px 24px;
    text-align: left;
    background-color: var(--secondary-bg-color);
    border-radius: $default-border-radius-small;
    box-shadow: $default-box-shadow;

    .conversation__message-input-label-field {
      margin-bottom: 5px;
      font-size: $default-font-size;
      line-height: $default-line-height;
    }

    input[disabled] {
      cursor: not-allowed;
    }

    input {
      width: 100%;
      height: 40px;
      padding: 11px 40px 11px 16px;
      box-sizing: border-box;
      font-size: $default-font-size;
      border: 1px solid var(--color-background-grayer);
      color: var(--color);
      -webkit-text-fill-color: rgb(118, 118, 118);
      opacity: 1;
      background-color: var(--bg-color);
      border-radius: 5px;
      appearance: none;
    }

    button.conversation__message-input-submit-btn {
      cursor: pointer;
      position: absolute;
      top: 0px;
      right: 0px;
      bottom: 0px;
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
      //background-color: $primary-color;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      user-select: none;

      > svg {
        position: absolute;
        height: 15px;
        width: 10px;
        top: 12px;
        right: 14px;
        stroke: rgb(188, 188, 188);
      }
    }

    svg.conversation__message-input-success {
      position: absolute;
      height: 12px;
      width: 15px;
      top: 14px;
      right: 14px;
      stroke: rgb(57, 192, 137);
    }
  }
</style>
